export const whiteLabelTheme = {
    primaryMain: '#494B57',
    primaryLight: '#d9d9d9'
}
